module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Hoi. Studio for Modern Pilates","short_name":"hoi","start_url":"/","display":"standalone","icon":"src/assets/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"2c3ac2d4c889d38e71a54bc91fae0563"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
